import { useAppDataContext } from '@cox/core-ui8/dist/AppDataContext'
import LinkContent from '../components/link'

const Link = () => {
  const { appData } = useAppDataContext()
  console.log('appData in Link page:', appData)
  const sections = (appData as any)?.page?.template?.sections || (appData as any)?.page?.sections || {}
  let linkConfigs = sections?.LinkContent || []
  console.log('linkConfigs length', linkConfigs.length)
  console.log('linkConfigs in Link page:', linkConfigs)
  const unAuthorizedEnv = sections?.unAuthorizedEnv ?? false
  const unAuthorizedEnvMessage = sections?.unAuthorizedEnvMessage || ''
  const apiKey = sections?.apiKey || ''

  return (
    <>
      <LinkContent
        linkConfigs={linkConfigs}
        unAuthorizedEnv={unAuthorizedEnv}
        unAuthorizedEnvMessage={unAuthorizedEnvMessage}
        apiKey={apiKey}
      />
    </>
  )
}

export default Link
